/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedObecListListResponse } from '../types/PaginatedObecListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type ObceListRequest = {} | null | undefined;
export type ObceListResponse = PaginatedObecListListResponse;

export type ObceListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;
};

/**
 * GET /dmx-server/obce/
 *
 * ```yaml
 * operationId: obce_list
 * tags:
 *   - obce
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedObecListList'
 *     description: ''
 * ```
 */
export const obceListOperation = (rest?: ObceListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/obce/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/obce/' };
  };

/**
 * GET /dmx-server/obce/
 *
 * ```yaml
 * operationId: obce_list
 * tags:
 *   - obce
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedObecListList'
 *     description: ''
 * ```
 */
export const obceList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: ObceListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedObecListListResponse>> => {
  const operation = obceListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/obce/
 */
export const useObceListResource = (
  query: ObceListQuery | null,
  useCached?: boolean,
): UseResource<ObceListResponse> => {
  return useResource<ObceListResponse>({
    path: query === null ? null : obceListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
